import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";
import React, { Suspense } from "react";

import { Layout } from "#components/Layout.tsx";
import type { RouterContext } from "#routerContext.ts";

const TanStackRouterDevtools = import.meta.env.PROD
    ? () => null // Render nothing in production
    : // oxlint-disable-next-line typescript/promise-function-async
      React.lazy(() =>
          // Lazy load in development
          // oxlint-disable-next-line promise/prefer-await-to-then
          import("@tanstack/react-router-devtools").then((res) => ({
              default: res.TanStackRouterDevtools,
          })),
      );

const ReactQueryDevtools = import.meta.env.PROD
    ? () => null // Render nothing in production
    : // oxlint-disable-next-line typescript/promise-function-async
      React.lazy(() =>
          // Lazy load in development
          // oxlint-disable-next-line promise/prefer-await-to-then
          import("@tanstack/react-query-devtools").then((res) => ({
              default: res.ReactQueryDevtools,
          })),
      );

const RouteComponent: React.FC = () => {
    return (
        <>
            <Layout>
                <Outlet />
            </Layout>
            <Suspense>
                <TanStackRouterDevtools />
                <ReactQueryDevtools initialIsOpen={false} />
            </Suspense>
        </>
    );
};

export const Route = createRootRouteWithContext<RouterContext>()({
    component: RouteComponent,
});
